import { useEffect, useState } from "react";
import axios from "axios";

const url = 'https://computer-quiz-backend.herokuapp.com/year-sections';

export const useGetSections = () => {
  const [sectionData, setSectionData] = useState();
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const { data } = await axios.get(url);
        setSectionData(data);
      } catch (error) {
        setError(error.message);
      }
    };

    fetchSections();
  }, []);

  return { sectionData, error };
};